import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreNotificationsEmailRoute: InvariantJiraRoute = {
	name: 'project-settings-core-notifications-notification-email',
	path: '/jira/core/projects/:projectKey/settings/notifications/notification-email',
	exact: true,
};
